import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

export default function SpecimenList({ coins }) {
    const { coinId } = useParams();
    const navigate = useNavigate();

    const selectedCoin = coins.find(c => c.pcgs_id === parseInt(coinId));

    if (!selectedCoin) return <Typography>Coin not found</Typography>;

    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'grade', headerName: 'Grade', width: 100, align: 'center' },
        { field: 'grader', headerName: 'Grader', width: 100, align: 'center' },
        { field: 'comments', headerName: 'Comments', flex: 1, minWidth: 200 },
        {
            field: 'purchase_price',
            headerName: 'Purchase Price',
            width: 150,
            type: 'number',
            valueFormatter: (value) => value ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value) : '-'
        },
        {
            field: 'pcgs_value',
            headerName: 'PCGS Value',
            width: 150,
            type: 'number',
            valueFormatter: (value) => value ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value) : '-'
        },
        { field: 'date_of_purchase', headerName: 'Purchased On', width: 150 },
        { field: 'storage_location', headerName: 'Location', width: 150 },
        { field: 'duplicate', headerName: 'Duplicate', width: 100, type: 'boolean' },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            renderCell: (params) => (
                <Link
                    component="button"
                    variant="body2"
                    onClick={() => navigate(`/edit-coin/${selectedCoin.pcgs_id}?specimenId=${params.row.id}`)}
                >
                    Edit
                </Link>
            )
        }
    ];

    return (
        <Box>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Link underline="hover" color="inherit" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
                    Home
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    onClick={() => {
                        const s = (selectedCoin.series_date ? `${selectedCoin.series_date} ` : '') + (selectedCoin.series_name || 'Other');
                        navigate(`/series/${encodeURIComponent(selectedCoin.denomination)}/${encodeURIComponent(s)}`);
                    }}
                    sx={{ cursor: 'pointer' }}
                >
                    {selectedCoin.denomination}
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    onClick={() => {
                        const s = (selectedCoin.series_date ? `${selectedCoin.series_date} ` : '') + (selectedCoin.series_name || 'Other');
                        navigate(`/series/${encodeURIComponent(selectedCoin.denomination)}/${encodeURIComponent(s)}`);
                    }}
                    sx={{ cursor: 'pointer' }}
                >
                    {(selectedCoin.series_date ? `${selectedCoin.series_date} ` : '') + (selectedCoin.series_name || 'Other')}
                </Link>
                <Typography color="text.primary">{selectedCoin.date}</Typography>
            </Breadcrumbs>

            <Paper elevation={3} sx={{ height: 600, width: '100%', mt: 2 }}>
                <Box sx={{ p: 2, bgcolor: 'background.default', borderBottom: 1, borderColor: 'divider' }}>
                    <Typography variant="h5" color="text.primary">
                        {selectedCoin.date} {selectedCoin.major}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        {selectedCoin.type} | PCGS #{selectedCoin.pcgs_id}
                    </Typography>
                </Box>
                <Box sx={{ p: 2, bgcolor: 'background.paper' }}>
                    <Typography variant="h6" gutterBottom color="primary">
                        My Specimens
                    </Typography>
                    <DataGrid
                        rows={selectedCoin.specimens || []}
                        columns={columns}
                        getRowId={(row) => row.id}
                        autoHeight
                        density="standard"
                        sx={{
                            border: 'none',
                            '& .MuiDataGrid-cell:focus': {
                                outline: 'none',
                            },
                        }}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
